module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_arrange.e666bfe2.svg";